<script lang="ts">
	import { format } from 'svelte-i18n';
	//Design system components
	import {
		DoubleDeviceButton,
		DoubleDeviceButtonV2,
		TripleDeviceButton,
		TripleDeviceButtonV2,
		type DeviceButtonV2PropsTypes,
		type DoubleDeviceButtonV2PropsTypes,
		type TripleDeviceButtonV2PropsTypes,
	} from '@Shelly/shelly-design-system';
	//Component
	import TemplateDirectionButton from './TemplateDirectionButton.svelte';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';

	let className = '';
	export { className as class };

	export let device: Device;
	export let statuses: VCInterfaceStatus[];
	export let isLoading = false;
	export let useV2Components = false;
	export let devBtnsV2Props: {
		deviceButtonV2?: Partial<DeviceButtonV2PropsTypes>;
		doubleDeviceButtonV2?: Partial<DoubleDeviceButtonV2PropsTypes>;
		tripleDeviceButtonV2?: Partial<TripleDeviceButtonV2PropsTypes>;
	} = {
		deviceButtonV2: { size: 's' },
		doubleDeviceButtonV2: { size: 's' },
		tripleDeviceButtonV2: { size: 's' },
	};

	let statusStop: VCInterfaceStatus | undefined;
	let statusCover: VCInterfaceStatus | undefined;

	$: statusStop = statuses.find((i) => /^(stop)$/.test(i.role));
	$: statusCover = statuses.find((i) => /^(status)$/.test(i.role));
</script>

{#if statusStop?.id && !statusCover?.id}
	<svelte:component
		this={useV2Components ? TripleDeviceButtonV2 : TripleDeviceButton}
		id="triple-button-window-cover-controller"
		aria-label={$format('button_label_close_open', { default: 'Close / Open' })}
		{isLoading}
		class={className}
		isActive={false}
		{...useV2Components ? devBtnsV2Props.tripleDeviceButtonV2 : {}}
	>
		<TemplateDirectionButton
			slot="buttonLeft"
			direction="open"
			{device}
			{statuses}
			{useV2Components}
			deviceButtonV2Props={devBtnsV2Props?.deviceButtonV2}
			bind:isLoading
		/>
		<TemplateDirectionButton
			slot="buttonMiddle"
			direction="stop"
			{device}
			{statuses}
			{useV2Components}
			deviceButtonV2Props={devBtnsV2Props?.deviceButtonV2}
			bind:isLoading
		/>
		<TemplateDirectionButton
			slot="buttonRight"
			direction="close"
			{device}
			{statuses}
			{useV2Components}
			deviceButtonV2Props={devBtnsV2Props?.deviceButtonV2}
			bind:isLoading
		/>
	</svelte:component>
{:else}
	<svelte:component
		this={useV2Components ? DoubleDeviceButtonV2 : DoubleDeviceButton}
		id="double-button-window-cover-controller"
		aria-label={$format('button_label_close_open', { default: 'Close / Open' })}
		{isLoading}
		class={className}
		{useV2Components}
		isActive={false}
		{...useV2Components ? devBtnsV2Props.doubleDeviceButtonV2 : {}}
	>
		<TemplateDirectionButton
			slot="buttonLeft"
			direction="open"
			{device}
			{statuses}
			bind:isLoading
			{useV2Components}
			deviceButtonV2Props={devBtnsV2Props?.deviceButtonV2}
		/>
		<TemplateDirectionButton
			slot="buttonRight"
			direction="close"
			{device}
			{statuses}
			{useV2Components}
			deviceButtonV2Props={devBtnsV2Props?.deviceButtonV2}
			bind:isLoading
		/>
	</svelte:component>
{/if}
